import React from "react";

type Props = {
  className?: string;
};
export const MicIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 14 19" fill="none">
      <path d="M6.61183 0C4.52565 0 2.8335 1.69213 2.8335 3.77833V9.44537C2.8335 11.5315 4.52563 13.2237 6.61183 13.2237C8.69802 13.2237 10.3902 11.5316 10.3902 9.44537V3.77833C10.3902 1.69216 8.69802 0 6.61183 0Z" />
      <path d="M12.9492 11.3345C12.224 13.7722 10.1297 15.622 7.55664 15.9903V17.9463C7.55664 18.4679 7.13338 18.8911 6.61183 18.8911C6.09028 18.8911 5.66702 18.4679 5.66702 17.9463V15.9903C3.09373 15.622 0.999644 13.7722 0.274489 11.3345C0.0956233 10.735 0 10.101 0 9.44579C0 8.92424 0.42326 8.50098 0.944809 8.50098C1.46636 8.50098 1.88962 8.92424 1.88962 9.44579C1.88962 9.91597 1.9578 10.3693 2.08442 10.7952C2.6653 12.7468 4.47433 14.168 6.61194 14.168C8.74955 14.168 10.5585 12.7469 11.1395 10.7952C11.2661 10.3693 11.3343 9.91597 11.3343 9.44579C11.3343 8.92424 11.7575 8.50098 12.2791 8.50098C12.8006 8.50098 13.2239 8.92424 13.2239 9.44579C13.2239 10.101 13.1282 10.735 12.9494 11.3345H12.9492Z" />
    </svg>
  );
};
